import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment";

import FormReceivingUnit from "./formReceivingUnit";
import DDLCompany from "../../../../modules/commons/DDLCompany";
import SimpleInput from "../../../../modules/SimpleInput";

import Button from "../../../../modules/commons/Button";
import moment from "moment";
const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class receivingUnit extends Component {
  constructor() {
    super();
    this.state = {
      rawData: [],
      dataTable: [
        [ "No PO MD 1", "No SL 1", "01-01-2019", "abc123", "daF1sin1", "Red", "John", "HP1", "A1A"],
        [ "No PO MD 2", "No SL 2", "02-02-2019", "def456", "daF2sin2", "Orange", "Jane", "HP2", "B2B"],
        [ "No PO MD 3", "No SL 3", "03-03-2019", "ghi789", "daF3sin3", "Yellow", "Bob", "HP3", "C3C"],
        [ "No PO MD 4", "No SL 4", "04-04-2019", "jkl012", "daF4sin4", "Green", "Mary", "HP4", "D4D"],
        [ "No PO MD 5", "No SL 5", "05-05-2019", "mno345", "daF5sin5", "red", "Tom", "HP5", "E5E"],
        [ "No PO MD 6", "No SL 6", "06-06-2019", "pqr678", "daF6sin6", "Indigo", "Sara", "HP6", "F6F"],
        [ "No PO MD 7", "No SL 7", "07-07-2019", "stu901", "daF7sin7", "Violet", "Chris", "HP7", "G7G"],
        [ "No PO MD 8", "No SL 8", "08-08-2019", "vwx234", "daF8sin8", "Pink", "Emma", "HP8", "H8H"],
        [ "No PO MD 9", "No SL 9", "09-09-2019", "yz567", "daF9sin9", "Magenta", "Alex", "HP9", "I9I"],
        [ "No PO MD 10", "No SL 10", "10-10-2019", "abc890", "daF10sin10", "Purple", "Ryan", "HP10", "J10J"],
        [ "No PO MD 11", "No SL 11", "11-11-2019", "def123", "daF11sin11", "Brown", "Liam", "HP11", "K11K"],
        [ "No PO MD 12", "No SL 12", "12-12-2019", "ghi456", "daF12sin12", "White", "Noah", "HP12", "L12L"],
        [ "No PO MD 13", "No SL 13", "13-01-2020", "jkl789", "daF13sin13", "Black", "Oliver", "HP13", "M13M"],
        [ "No PO MD 14", "No SL 14", "14-02-2020", "mno012", "daF14sin14", "Gray", "Elijah", "HP14", "N14N"],
        [ "No PO MD 15", "No SL 15", "15-03-2020", "pqr345", "daF15sin15", "Silver", "William", "HP15", "O15O"],
        [ "No PO MD 16", "No SL 16", "16-04-2020", "stu678", "daF16sin16", "Gold", "James", "HP16", "P16P"],
        [ "No PO MD 17", "No SL 17", "17-05-2020", "vwx901", "daF17sin17", "Beige", "Benjamin", "HP17", "Q17Q"],
        [ "No PO MD 18", "No SL 18", "18-06-2020", "yz234", "daF18sin18", "Maroon", "Lucas", "HP18", "R18R"],
        [ "No PO MD 19", "No SL 19", "19-07-2020", "abc567", "daF19sin19", "Mint", "Henry", "HP19", "S19S"],
        [ "No PO MD 20", "No SL 20", "20-08-2020", "def890", "daF20sin20", "Navy", "Owen", "HP20", "T20T"]
      ],
      selectedIndex: [],
      createVisible: false,
      updateVisible: false,
      deletePopUpVisible: false,
      savePopUpVisible: false,
      loadSave: false,
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      buttonAccess: {},
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    let payload = {
      limit: limit,
      offset: page,
      filter: this.state.table_query,
      companyId: this.state.dataDto.companyId,
      companyGroupId: null,
      category: null,
      isActive: null,
      sortBy: this.state.dataDto.sortBy ?? "",
      orderBy: this.state.dataDto.orderBy ?? "",
    };

    let res = await API.create("LOCAL_RECEIVINGUNIT").getUnit(payload);
    if (res.ok) {
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        // console.log(JSON.stringify(res.data.data, null, 2));
        let dataTable =
          res.data.data &&
          res.data.data.map((value) => {
            const { 
                nopomd,
                noshiping,
                tglsl,
                noka,
                nosin,
                warna,
                namakonsumen,
                utpcode,
                type,  
            } =value;
            return [
                nopomd,
                noshiping,
                tglsl,
                noka,
                nosin,
                warna,
                namakonsumen,
                utpcode,
                type,
            ];
          });
        this.setState({
          rawData: res.data.data && res.data.data.listUser,
          dataTable,
          toCount: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
    });
  };

  onChangeDate = (e, name) => {
    this.setState({
      data: {
        ...this.state.data,
        [name]: M(e).format("DD-MM-YYYY"),
      },
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  openUpdateForm = () => {
    this.setState({ updateVisible: !this.state.updateVisible });
  };

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openDeletePopup = (index) => {
    this.setState({
      deletePopUpVisible: !this.state.deletePopUpVisible,
      selectedIndex: index,
    });
  };

  columnsUser = [
    { name: "No PO MD" },
    { name: "No Shiping" },
    { name: "Tanggal SL" },
    { name: "NoKa" },
    { name: "NoSin" },
    { name: "Warna" },
    { name: "Nama Konsumen" },
    { name: "UTP code" },
    { name: "Type" },

    // {
    //     name: "Action",
    //     options: {
    //         customBodyRender: (val, tableMeta) => {
    //             return (
    //                 <div style={{ width: '115px' }}>
    //                     <Button
    //                         className="btnAct"
    //                         style={{ marginRight: 15, backgroundColor: 'transparent' }}
    //                         onClick={this.opSidePage('slide-menu-1', tableMeta.rowIndex, 'companyGroup')}
    //                         permission=""
    //                     >
    //                         <i className="fa fa-lw fa-pencil-alt"
    //                             style={{ backgroundColor: 'transparent', color: '#004c97', fontSize: 20 }} />
    //                     </Button>
    //                     {/* <Button
    //                         className="btnAct"
    //                         style={{ marginRight: 15, backgroundColor: 'transparent' }}
    //                         onClick={() => this.openDeletePopup(tableMeta.rowIndex)}
    //                         permission={this.state.buttonAccess.btnDelete}
    //                     >
    //                         <i className="fa fa-lw fa-trash-alt"
    //                             style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
    //                     </Button> */}
    //                     <Button
    //                         className="btnAct"
    //                         style={{ marginRight: 15, backgroundColor: 'transparent' }}
    //                         onClick={this.opSidePage('slide-menu-view', tableMeta.rowIndex)}
    //                         permission=""
    //                     >

    //                         <i className="fa fa-lw fa-ellipsis-v"
    //                             style={{ backgroundColor: 'transparent', color: '#004c97', fontSize: 20 }} />
    //                     </Button>
    //                 </div>
    //             );
    //         }
    //     }
    // }
  ];

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };
  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      // serverSide: true,
      filter: false,
      selectableRowsHeader: true,
      selectableRows: "multiple",
      count: toCount,
      searchText: table_query,
      search: false,
      viewColumns: false,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }

        let columnOrder = "";

        if (changedColumn === "Company") {
          columnOrder = "companyCode";
        }

        if (changedColumn === "Username") {
          columnOrder = "username";
        }

        if (changedColumn === "Email") {
          columnOrder = "email";
        }

        if (changedColumn === "Category") {
          columnOrder = "category";
        }

        if (changedColumn === "Employee Name") {
          columnOrder = "name";
        }

        if (changedColumn === "Status") {
          columnOrder = "status";
        }

        this.columnsUser.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });

        this.setState(
          {
            dataDto: {
              ...this.state.dataDto,
              sortBy: columnOrder,
              orderBy: order,
            },
          },
          () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
          }
        );
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div className="main-slider">
        <div className="padding-tbl-monitoring">
          <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>Receiving Unit</Tab>
            </TabList>
            <TabPanel>
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <SimpleDate
                    label={"Start Date"}
                    date={this.state.data.startDate}
                    minDate={new Date()}
                    onChange={(date) => this.onChangeDate(date, "startDate")}
                  />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ width: 200, marginRight: 20 }}>
                      <DDLCompany
                        label={"No SL"}
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />
                    </div>

                    <div>
                      <SimpleInput
                        label={"Kode"}
                        name="kodeId"
                        // readOnly={this.props.type !== "create"}
                        value={this.state.data.kodeId}
                        onChange={this.onchangeInput}
                      />
                    </div>
                  </div>
                </div>

                {/* <div className='col-3 padding-top-25px'>
                                    <Button
                                        type='button'
                                        className='btn btn-circle background-red'
                                        style={{ marginRight: 5 }}
                                        onClick={() => this.handleSearch(true)}
                                        permission={this.state.buttonAccess.btnSearch}
                                    >
                                        <i className='fa fa-1x fa-search' />
                                    </Button>
                                    <Button
                                        type='button'
                                        className='btn btn-circle background-red'
                                        style={{ marginRight: 10 }}
                                        onClick={this.handleClearUser}
                                        permission={this.state.buttonAccess.btnClear}
                                    >
                                        <i className='fa fa-1x fa-sync-alt' />
                                    </Button>
                                </div> */}
              </div>
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    key={toCount}
                    title={"Receiving Unit"}
                    subtitle={"Setting data of Receiving Unit"}
                    data={this.state.dataTable}
                    columns={this.columnsUser}
                    options={tableOptions}
                    // buttonCreate={this.state.buttonAccess.btnAdd}
                    // onCreate={this.openCreateForm.bind(this)}
                  />
                </MuiThemeProvider>
              </div>
            </TabPanel>
          </Tabs>
          <div
            style={{ float: "right", marginRight: "1vw" }}
            className="padding-top-30px padding-bottom-20px"
          >
            <button
              style={{ marginLeft: "15px" }}
              className="btn btn-back"
              type="button"
            >
              <span>BACK</span>
            </button>
            <button
              style={{ marginLeft: "15px" }}
              className="btn btn-back"
              type="button"
              onClick={this.openCreateForm.bind(this)}
            >
              <span>PROCCESS</span>
            </button>
          </div>
        </div>

        <div>
          {this.state.createVisible && (
            <FormReceivingUnit
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.updateVisible && (
            <FormReceivingUnit
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.savePopUpVisible && (
            <PopUp
              type={"save"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp.bind(this)}
            />
          )}

          {this.state.deletePopUpVisible && (
            <PopUp
              type={"delete"}
              class={"app-popup app-popup-show"}
              onClickDelete={this.handleDelete}
              onClick={this.openDeletePopup}
              isLoading={this.state.loadSave}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    h1Module: state.h1Module,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(receivingUnit);
